module.exports = __webpack_public_path__ + "static/img/logo13.e1dfee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo13.png
// module id = 4Djr
// module chunks = 1